
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.833 6.667c0-2.3-2.05-4.167-4.583-4.167-2.534 0-4.583 1.867-4.583 4.167h1.666l.833-.834.834.834h3.333m2.5-.717A4.85 4.85 0 0113.75 5c2.533 0 4.583 1.867 4.583 4.167h-2.5L15 8.333l-.834.834h-2.5","fill":"currentColor"}}),_c('path',{attrs:{"d":"M4.908 8.091c-1.791 1.792-1.916 4.559-.291 6.192l3.533-3.542.583-.583.592-.592L11.092 7.8C9.467 6.166 6.7 6.3 4.908 8.09z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M8.75 10c.525 2.678-.379 7.023-1.25 9.166h4.198c2.099-5.893-.34-11.19-.865-13.333","fill":"currentColor"}})])
          )
        }
      }
    